module.exports = __webpack_public_path__ + "img/ep2-1.7cb4fdcb.png";